export default __webpack_public_path__ + "static/media/companytab_banner.7fe36929.png";